module.exports = __webpack_public_path__ + "img/pic5.e5386fa6.png";